<template lang="pug">
b-row
  b-col(cols="12")
    div
      form-wizard.wizard-vertical.mb-3(
        color="#498ceb",
        layout="horizontal",
        :title="null",
        :subtitle="null",
        :finish-button-text="$t('message.submit')",
        :back-button-text="$t('message.previous')",
        :next-button-text="$t('message.next')",
        :hide-buttons="readOnly",
        ref="caseForm"
      )
        // Title
        h4(v-if="data.state || data.stage" slot="title", class="pt-1 mb-0")
          span(v-if="data.state")
            span
              | {{ $t('improvement_opp.state') }} &#11166; 
            span(:class="data.state === 'completed' ? 'text-success' : data.state === 'delayed' ? 'text-danger' : 'text-primary'", style="font-weight: 600")
              | {{ $t(data.state) }}
            span(v-if="data.state === 'completed' && data.isCompletedOverdue", class="text-danger", style="font-weight: 600")
              |  ({{ $t('delayed') }})
          span(v-if="data.state && data.stage", class="mx-1")  | 
          span(v-if="data.stage")
            span
              | {{ $t('actualStage') }} &#11166; 
            span(class="text-primary", style="font-weight: 600")
              | {{ $t(`caseStages.${displayStage}`) }}

        // Buttons personalization
        template(v-slot:footer="slotProps")
          div(class="wizard-footer d-flex justify-content-between align-items-center")
            b-button(
              v-if="!readOnly"
              variant="outline-secondary"
              @click="goToPreviousTab"
              :disabled="slotProps.activeTabIndex === 0"
            )
              | < &nbsp; {{ $t('message.previous') }}

            div(class="ml-auto d-flex align-items-center")
              b-button(
                v-if="!readOnly && !slotProps.isLastStep"
                variant="primary"
                class="mr-2"
                @click="goToNextTab"
              )
                | {{ $t('message.next') }} &nbsp; >

              b-button(
                v-if="!readOnly"
                variant="success"
                @click="handleSubmit"
              )
                | {{ $t('message.submit') }}

        // Identification
        tab-content(:title="$t('label.identification')")
          validation-observer(ref="identificationTab", tag="form")
            b-row
              // Code
              b-col(v-if="data.code", md="2")
                b-form-group(:label="$t('label.code')", :label-for="$t('label.code')")
                  b-form-input(v-model="data.code", :disabled="true")

              // Title
              b-col(:md="data.code ? '10' : '12'")
                b-form-group(:label="$t('label.Title')", :label-for="$t('label.Title')")
                  validation-provider(:name="$t('label.Title')", rules="required", v-slot="{ errors }")
                    b-form-input(v-model="data.note", trim, :disabled="readOnly || stages[data.stage] > 2", :placeholder="$t('placeholder.improvement_title')")
                    small(class="text-danger") {{ errors[0] }}

            b-row
              // Associated Cases
              b-col(md="6")
                b-form-group(:label="$t('label.associated_cases')", :label-for="$t('label.associated_cases')")
                  v-select(
                    v-model="data.associatedCases"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="improvements"
                    :reduce="improvement => improvement.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.associated_cases')"
                  )

              // Link to Associated Case
              //- b-col(md="6")
              //-   b-form-group(:label="$t('label.associated_case_link')", :label-for="$t('label.associated_case_link')")
              //-     b-button(
              //-       variant="warning"
              //-       size="sm"
              //-       :style="{ marginTop: '4px' }"
              //-       :disabled="!data.associatedCase"
              //-       @click="openCase(data.associatedCase)"
              //-     )
              //-       | {{ $t('message.see_case') }}

              // Document
              b-col(md="6")
                b-form-group(:label="$t('Documents')", :label-for="$t('Documents')")
                  // Document Repository
                  document-repository(
                    :documents="documentFiles"
                    :keys="data.imageKey || []"
                    :read-only="readOnly || stages[data.stage] > 2"
                    @add="handleAddDocuments"
                    @delete="handleDeleteDocuments"
                  )

            b-row
              // Company
              b-col(md="6")
                b-form-group(:label="$t('label.company')", :label-for="$t('label.company')")
                  v-select(
                    v-model="data.company"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="companies"
                    :reduce="company => company.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.companies')"
                  )

              // Business Activity
              b-col(md="6")
                b-form-group(:label="$t('label.businessActivity')", :label-for="$t('label.businessActivity')")
                  v-select(
                    v-model="data.businessActivity"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="ids"
                    :reduce="id => id.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.id')"
                  )

            b-row
              // Process
              b-col(md="6")
                b-form-group(:label="$t('label.process')", :label-for="$t('label.process')")
                  v-select(
                    v-model="data.process"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="processes"
                    :reduce="process => process.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.process')"
                  )

              // Crime
              b-col(md="6")
                b-form-group(:label="$t('label.crime')", :label-for="$t('label.crime')")
                  v-select(
                    v-model="data.crime"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="crimes"
                    :reduce="crime => crime.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.crimeSelect')"
                  )

            b-row
              // Control
              b-col(md="6")
                b-form-group(:label="$t('label.control')", :label-for="$t('label.control')")
                  v-select(
                    v-model="data.control"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="controls"
                    :reduce="control => control.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.controlSelect')"
                  )

              // Control Responsible
              b-col(md="6")
                b-form-group(:label="$t('label.controlResponsible')", :label-for="$t('label.controlResponsible')")
                  v-select(
                    v-model="data.controlResponsible"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="workersSupervised"
                    :selectable="worker => !worker.deleted"
                    :reduce="worker => worker.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.controlResponsible')"
                  )

            b-row
              // Description
              b-col(md="12")
                b-form-group(
                  :label="$t('label.description')",
                  :label-for="$t('label.description')",
                )
                  b-form-textarea(
                    v-model="data.description"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('message.write_a_description')"
                  )

            // Linked Behaviours (from evaluation)
            b-row(v-if="linkedBehavioursAvailable")
              b-col(md="12")
                b-form-group(:label="$t('label.linked_behaviours')")
                  b-card.border-warning
                    b-card-text
                      p.mb-2(v-if="!(readOnly || stages[data.stage] > 2)")
                        | {{ availableBehaviours.length ? $t('message.select_behaviours_to_link') : $t('message.no_negative_behaviours') }}
                      b-form-checkbox(
                        v-for="(behaviour, index) in availableBehaviours"
                        :key="index"
                        v-model="behaviour.selected"
                        :disabled="readOnly || stages[data.stage] > 2"
                        class="mb-2"
                      )
                        strong {{ behaviour.activityName }} - {{ behaviour.nameFormatted }}
                        div.ml-4(v-if="behaviour.behaviourAnswer")
                          | {{ $t('message.tableHeader.answer') }}: {{ behaviour.behaviourAnswer === 'true' ? $t('message.yes') : 'No' }}
                        div.ml-4(v-if="behaviour.behaviourComment")
                          | {{ $t('label.comment') }}: {{ behaviour.behaviourComment }}

        // Responsibles
        tab-content(:title="$t('message.responsibles')")
          validation-observer(ref="responsiblesTab", tag="form") 
            b-row
              // Operational Areas
              b-col(md="12")
                b-form-group(:label="$t('label.operationalAreas')", :label-for="$t('label.operationalAreas')")
                  v-select(
                    v-model="data.areas"
                    label="title"
                    :multiple="!readOnly && stages[data.stage] <= 2"
                    :options="locations"
                    :reduce="location => location.value",
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.operationalAreas')"
                  )

            b-row
              // Registration Responsible
              b-col(md="6")
                b-form-group(:label="$t('label.registration_responsible')", :label-for="$t('label.registration_responsible')")
                  validation-provider(:name="$t('label.registration_responsible')", rules="required", v-slot="{ errors }")
                    v-select(
                      v-model="data.assignee"
                      label="title"
                      :options="workersTotal"
                      :selectable="worker => !worker.deleted"
                      :reduce="worker => worker.value"
                      :disabled="readOnly || stages[data.stage] > 2"
                      :placeholder="$t('placeholder.registration_responsible')"
                    )
                    small(class="text-danger") {{ errors[0] }}

              // Due date for registration responsible
              b-col(md="3")
                b-form-group(:label="$t('label.due_date')", :label-for="$t('label.due_date')")
                  validation-provider(:name="$t('label.due_date')", rules="required", v-slot="{ errors }")
                    flat-pickr(
                      v-model="data.dueDate"
                      :config="flatPickrConfig"
                      class="form-control"
                      :disabled="readOnly || stages[data.stage] > 2"
                    )
                    small(class="text-danger") {{ errors[0] }}

            b-row
              // Proposal Responsible
              b-col(md="6")
                b-form-group(:label="$t('label.proposal_responsible')", :label-for="$t('label.proposal_responsible')")
                  v-select(
                    v-model="data.assignee"
                    label="title"
                    :options="workersTotal"
                    :selectable="worker => !worker.deleted"
                    :reduce="worker => worker.value"
                    :disabled="true"
                    :placeholder="$t('placeholder.proposal_responsible')"
                  )

              // Due date for proposal responsible
              b-col(md="3")
                b-form-group(:label="$t('label.due_date')", :label-for="$t('label.due_date')")
                  flat-pickr(
                    v-model="data.proposalDueDate"
                    :config="flatPickrConfig"
                    class="form-control"
                    :disabled="readOnly || stages[data.stage] > 2"
                  )

              // Business days
              b-col(md="2")
                b-form-group
                  label.col-form-label.d-flex.align-items-center.py-0(:style="{ marginBottom: '4px' }")
                    span {{ $t('message.duration') }}
                    InformationButton.py-0(text="message.businessDaysDifference")

                  b-form-input(
                    :value="proposalBusinessDays"
                    disabled
                  )

            b-row
              // Approval Responsible
              b-col(md="6")
                b-form-group(:label="$t('label.approval_responsible')", :label-for="$t('label.approval_responsible')")
                  v-select(
                    v-model="data.approvalResponsible"
                    label="title"
                    :options="workersTotal"
                    :selectable="worker => !worker.deleted"
                    :reduce="worker => worker.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.approval_responsible')"
                  )

              // Due date for approval responsible
              b-col(md="3")
                b-form-group(:label="$t('label.due_date')", :label-for="$t('label.due_date')")
                  flat-pickr(
                    v-model="data.approvalDueDate"
                    :config="flatPickrConfig"
                    class="form-control"
                    :disabled="readOnly || stages[data.stage] > 2"
                  )

              // Business days
              b-col(md="2")
                b-form-group
                  label.col-form-label.d-flex.align-items-center.py-0(:style="{ marginBottom: '4px' }")
                    span {{ $t('message.duration') }}
                    InformationButton.py-0(text="message.businessDaysDifference")

                  b-form-input(
                    :value="approvalBusinessDays"
                    disabled
                  )

            b-row
              // Verification Responsible
              b-col(md="6")
                b-form-group(:label="$t('label.verification_responsible')", :label-for="$t('label.verification_responsible')")
                  v-select(
                    v-model="data.verificationResponsible"
                    label="title"
                    :options="workersTotal"
                    :selectable="worker => !worker.deleted"
                    :reduce="worker => worker.value"
                    :disabled="readOnly || stages[data.stage] > 2"
                    :placeholder="$t('placeholder.verification_responsible')"
                  )

              // Due date for verification responsible
              b-col(md="3")
                b-form-group(:label="$t('label.due_date')", :label-for="$t('label.due_date')")
                  flat-pickr(
                    v-model="data.verificationDueDate"
                    :config="flatPickrConfig"
                    class="form-control"
                    :disabled="readOnly || stages[data.stage] > 2"
                  )

              // Business days
              b-col(md="2")
                b-form-group
                  label.col-form-label.d-flex.align-items-center.py-0(:style="{ marginBottom: '4px' }")
                    span {{ $t('message.duration') }}
                    InformationButton.py-0(text="message.businessDaysDifference")

                  b-form-input(
                    :value="verificationBusinessDays"
                    disabled
                  )

        // Analysis
        tab-content(v-if="readOnly || stages[data.stage] >= 3", :title="$t('message.analysis')")
          validation-observer(ref="analysisTab", tag="form")
            // 5 why method
            b-row
              b-col(md="6")
                h5.mb-1
                  | {{ $t('label.WhyMethod') }}
            // Problem
            b-row
              b-col(md="12")
                b-form-group(:label="$t('label.Problem')", :label-for="$t('label.Problem')")
                  b-form-textarea(v-model="data.problemStatement", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis", :placeholder="$t('placeholder.problem_statement')")
            // 5 whys
            b-row
              b-col(md="4")
                b-form-group(:label="$t('label.Why1')", :label-for="$t('label.Why1')")
                  b-form-textarea(v-model="data.why1", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis", :placeholder="$t('placeholder.first_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="1" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why2')", :label-for="$t('label.Why2')")
                  b-form-textarea(v-model="data.why2", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 2", :placeholder="$t('placeholder.inner_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="2" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why3')", :label-for="$t('label.Why3')")
                  b-form-textarea(v-model="data.why3", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 3", :placeholder="$t('placeholder.inner_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="3" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why4')", :label-for="$t('label.Why4')")
                  b-form-textarea(v-model="data.why4", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 4", :placeholder="$t('placeholder.inner_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="4" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why5')", :label-for="$t('label.Why5')")
                  b-form-textarea(v-model="data.why5", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 5", :placeholder="$t('placeholder.root_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="5" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                    small
                      | {{ $t('label.rootCause') }}

            // Action Plans Title
            b-row(class="mt-1")
              b-col(md="12")
                h5.mb-1
                  | {{ $t('label.actionPlans') }}

            b-row(v-if="!readOnly")
              // Action plan type
              b-col(md="4")
                b-form-group(:label="$t('label.actionPlanType')", :label-for="$t('label.actionPlanType')")
                  validation-provider(:name="$t('label.actionPlanType')", v-slot="{ errors }")
                    v-select(
                      v-model="actionPlanType"
                      label="title"
                      :options="actionPlanOptions"
                      :reduce="(state) => state.value"
                      :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis"
                      :placeholder="$t('placeholder.actionPlanType')"
                    )
                    small(class="text-danger") {{ errors[0] }}

              // Add action plan
              b-col(md="4")
                b-form-group(:label="$t('label.actionPlan')", :label-for="$t('label.actionPlan')")
                  b-button(
                    type="button"
                    variant="success"
                    @click="addActionPlan"
                    :disabled="!pacEnabled || stages[data.stage] > 3 && allActionPlansBeyondAnalysis"
                    )
                      | {{ $t('message.addActionPlan') }}
                  div(v-show="!pacEnabled && (stages[data.stage] <= 3 || !allActionPlansBeyondAnalysis)")
                    small(class="text-danger") {{ actionPlanType ? $t('message.5WhysMustBeComplete') : $t('message.youMustSelectActionPlanType') }}
            
            // No action plans message
            ul.list-group.mt-1.mb-2(v-if="!actionPlans.length")
              li(class="list-group-item text-center text-muted font-weight-bold bg-light")
                | {{ $t('message.no_action_plans') }}

            // Action plans list
            b-row(v-for="(item, index) in actionPlans" :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'analysis' ? 'border-warning' : ''}`")
              b-col(v-if="index % 2 === 0", md="12")
                hr(:class="index ? 'my-2' : 'mb-2'")

              b-col(md="3")
                b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
                  validation-provider(:name="`${$t('label.actionPlanName')} ${index + 1}`", rules="required", v-slot="{ errors }")
                    b-form-textarea(v-model="item.name", :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')", :placeholder="$t('placeholder.name')")
                    small(class="text-danger") {{ errors[0] }}
              
              b-col(md="3")
                b-form-group(:label="$t('label.Type')", :label-for="$t('label.Type')")
                  validation-provider(:name="`${$t('label.Type')} ${index + 1}`", rules="required", v-slot="{ errors }")
                    v-select(v-model="item.type", label="title", :options="actionPlanOptions", :reduce="(state) => state.value", :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')", :placeholder="$t('placeholder.actionPlanType')")
                    small(class="text-danger") {{ errors[0] }}
              
              b-col(md="6")
                b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
                  b-form-textarea(v-model="item.description", :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')", :placeholder="$t('placeholder.action_plan_description')")

              b-col(md="4")
                b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
                  validation-provider(:name="`${$t('label.action_plan_responsible')} ${index + 1}`", rules="required", v-slot="{ errors }")
                    v-select(
                      v-model="item.executionResponsible"
                      label="title"
                      :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')"
                      :options="workersTotal"
                      :selectable="worker => !worker.deleted"
                      :reduce="worker => worker.value"
                      :placeholder="$t('placeholder.action_plan_responsible')"
                    )
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="2")
                b-form-group(:label="$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)", label-for="startDate")
                  validation-provider(:name="`${$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)} ${index + 1}`", rules="required", v-slot="{ errors }")
                    flat-pickr(
                      v-model="item.startDate"
                      :config="item.startDateConfig"
                      :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')"
                      class="form-control"
                    )
                    small(class="text-danger") {{ errors[0] }}
              
              b-col(v-if="item.type === 'in_term'", md="2")
                b-form-group(:label="$t('label.endDate')", :label-for="$t('label.endDate')")
                  validation-provider(:name="`${$t('label.endDate')} ${index + 1}`", rules="required", v-slot="{ errors }")
                    flat-pickr(
                      v-model="item.endDate"
                      :config="(readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')) ? flatPickrConfig : item.endDateConfig"
                      :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')"
                      class="form-control"
                    )
                    small(class="text-danger") {{ errors[0] }}
              
              b-col(v-if="item.type === 'immediate'", :md="item.evidence_key && item.evidence_key.length ? '2' : '4'")
                b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
                  // Document Repository
                  document-repository(
                    :documents="item.evidenceFile"
                    :keys="item.evidence_key || []"
                    :read-only="item.evidence_key && item.evidence_key.length > 0"
                    type="evidence"
                    @add="(evidences) => handleAddEvidences(evidences, index)"
                    @delete="(evidenceIndex) => handleDeleteEvidences(evidenceIndex, index)"
                  )

                  small(v-if="!(item.evidenceFile && item.evidenceFile.length) && !(item.evidence_key && item.evidence_key.length)", class="text-danger")
                    | {{ $t('message.upload_evidence_required') }}
                    
              b-col(md="2" class="mt-2")
                b-button(
                  v-if="!readOnly"
                  class="mr-1"
                  type="button"
                  variant="danger"
                  :disabled="!!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')"
                  v-b-modal="`modal ${item._id || index}`"
                )
                  | {{ $t('message.delete') }}
                
                b-modal(
                  :id="`modal ${item._id || index}`"
                  centered
                  no-close-on-backdrop
                  modal-class="modal-danger"
                  ok-variant="danger"
                  cancel-variant="outline-secondary"
                  :title="$t('message.confirm_action')"
                  :ok-title="$t('message.delete')"
                  :cancel-title="$t('message.cancel')"
                  @ok="deleteActionPlan(item._id, index)"
                )
                  | {{ $t('message.confirm_delete_action_plan') }}

              b-col(md="4")
                b-form-checkbox(v-model="item.isRootCause" @change="(checked) => handleCheck(checked, index)" :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.assignee && role !== 'consultant')")
                  small
                    | {{ $t('label.rootCause') }}
              
              b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
                small
                  | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

              b-col(v-if="index % 2 === 0", md="12")
                hr(class="mb-2")

        // Approval
        tab-content(v-if="readOnly || stages[data.stage] >= 4", :title="$t('message.approval')")
          validation-observer(ref="approvalTab", tag="form")
            // Total approval title
            b-row
              b-col(md="6")
                h5.mb-1
                  | {{ $t('label.globalApproval') }}

            // Approve all action plans
            b-row
              b-col(:md="approveAllCommentEnabled ? '4' : '12'")
                b-form-group(:label="$t('label.approveAllActionPlans')", :label-for="$t('label.approveAllActionPlans')")
                  b-button(
                    type="button"
                    variant="success"
                    @click="approveAllActionPlans"
                    :disabled="!approveAllEnabled || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'"
                  )
                    | {{ $t('message.approveAll') }}
                  small(v-if="!approveAllEnabled && data.stage === 'approval' && (userData.worker_id.$oid === data.approvalResponsible || role === 'consultant')", class="text-danger ml-1") {{ $t('message.mustSeeAllEvidences') }}
              b-col(v-if="approveAllCommentEnabled", md="8")
                b-form-group(:label="$t('label.approvalComment')", :label-for="$t('label.approvalComment')")
                  validation-provider(:name="$t('label.approvalComment')", :rules="data.stage === 'approval' ? 'required' : ''", v-slot="{ errors }")
                    b-form-textarea(v-model="data.approvalComment", :disabled="stages[data.stage] > 4", :placeholder="$t('placeholder.comment')")
                    small(class="text-danger") {{ errors[0] }}

            // 5 why method
            b-row
              b-col(md="6")
                h5.my-1
                  | {{ $t('label.WhyMethod') }}

            // Problem
            b-row
              b-col(md="12")
                b-form-group(
                  :label="$t('label.Problem')",
                  :label-for="$t('label.Problem')"
                )
                  b-form-textarea(
                    v-model="data.problemStatement"
                    :disabled="true"
                    :placeholder="$t('placeholder.problem_statement')"
                  )
            // 5 whys
            b-row
              b-col(md="4")
                b-form-group(:label="$t('label.Why1')", :label-for="$t('label.Why')")
                  b-form-textarea(v-model="data.why1", :disabled="true", :placeholder="$t('placeholder.first_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="1" :unchecked-value="100" class="custom-mt" :disabled="true")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why2')", :label-for="$t('label.Why')")
                  b-form-textarea(v-model="data.why2", :disabled="true", :placeholder="$t('placeholder.inner_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="2" :unchecked-value="100" class="custom-mt" :disabled="true")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why3')", :label-for="$t('label.Why')")
                  b-form-textarea(v-model="data.why3", :disabled="true", :placeholder="$t('placeholder.inner_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="3" :unchecked-value="100" class="custom-mt" :disabled="true")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why4')", :label-for="$t('label.Why')")
                  b-form-textarea(v-model="data.why4", :disabled="true", :placeholder="$t('placeholder.inner_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="4" :unchecked-value="100" class="custom-mt" :disabled="true")
                    small
                      | {{ $t('label.rootCause') }}
              b-col(md="4")
                b-form-group(:label="$t('label.Why5')", :label-for="$t('label.Why')")
                  b-form-textarea(v-model="data.why5", :disabled="true", :placeholder="$t('placeholder.root_cause')")
                  b-form-checkbox(v-model="data.rootCause" :value="5" :unchecked-value="100" class="custom-mt" :disabled="true")
                    small
                      | {{ $t('label.rootCause') }}
            
            // Title
            b-row(class="mt-1")
              b-col(md="12")
                h5(class="mb-0")
                  | {{ $t('label.actionPlans') }}

            // No action plans message
            ul.list-group.mt-1.mb-2(v-if="!actionPlans.length")
              li(class="list-group-item text-center text-muted font-weight-bold bg-light")
                | {{ $t('message.no_action_plans') }}

            // Action plans list
            b-row(v-for="(item, index) in actionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'approval' ? 'border-warning' : ''}`")
              b-col(v-if="index % 2 === 0", md="12")
                hr(:class="index ? 'my-2' : 'mb-2'")

              b-col(md="3")
                b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
                  b-form-textarea(v-model="item.name", :disabled="true", :placeholder="$t('placeholder.name')")

              b-col(md="3")
                b-form-group(:label="$t('label.Type')", :label-for="$t('label.Type')")
                  v-select(v-model="item.type", label="title", :options="actionPlanOptions", :reduce="(state) => state.value", :disabled="true", :placeholder="$t('placeholder.actionPlanType')")
              
              b-col(md="6")
                b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
                  b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")

              b-col(md="6")
                b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
                  v-select(
                    v-model="item.executionResponsible"
                    label="title"
                    :disabled="true"
                    :options="workersTotal"
                    :selectable="worker => !worker.deleted"
                    :reduce="worker => worker.value"
                    :placeholder="$t('placeholder.action_plan_responsible')"
                  )

              b-col(md="3")
                b-form-group(:label="$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)", label-for="startDate")
                  flat-pickr(
                    v-model="item.startDate"
                    :config="flatPickrConfig"
                    :disabled="true"
                    class="form-control"
                  )
                
              b-col(v-if="item.type === 'in_term'", md="3")
                b-form-group(:label="$t('label.endDate')", :label-for="$t('label.endDate')")
                  flat-pickr(
                    v-model="item.endDate"
                    :config="flatPickrConfig"
                    :disabled="true"
                    class="form-control"
                  )
              
              b-col(v-else, md="3")
                b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
                  // Document Repository
                  document-repository(
                    :documents="[]"
                    :keys="item.evidence_key || []"
                    :read-only="true"
                    type="evidence"
                    @evidence-viewed="handleEvidenceViewed(item._id, $event, 'approval')"
                  )
            
              b-col(md="3")
                b-form-group(:label="$t('message.approval')", :label-for="$t('message.approval')")
                  validation-provider(:name="`${$t('message.approval')} ${index + 1}`", :rules="item.stage === 'approval' ? 'required' : ''", v-slot="{ errors }")
                    v-select(v-model="item.approvalResult", :disabled="item.stage !== 'approval' || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'", label="title", :options="resultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="3")
                b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
                  validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'approval' ? 'required' : ''", v-slot="{ errors }")
                    v-select(v-model="item.approvalNextStage", :disabled="item.approvalResult !== 'rejected' || item.stage !== 'approval' || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'", label="title", :options="item.type === 'immediate' ? correctiveStageOptions : inTermApprovalStageOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="6")
                b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
                  validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'approval' && !approveAllCommentEnabled ? 'required' : ''", v-slot="{ errors }")
                    b-form-textarea(v-model="item.approvalComment", :disabled="item.stage !== 'approval' || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'", :placeholder="$t('placeholder.comment')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="4")
                b-form-checkbox(v-model="item.isRootCause" :disabled="true")
                  small
                    | {{ $t('label.rootCause') }}

              b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
                small
                  | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

              b-col(v-if="index % 2 === 0", md="12")
                hr(class="mb-2")
        
        // Corrective
        tab-content(v-if="readOnly || stages[data.stage] >= 5", :title="$t('message.corrective')")
          validation-observer(ref="correctiveTab", tag="form")
            // Title
            b-row
              b-col(md="12")
                h5.mb-1
                  | {{ $t('label.inTermActionPlans') }}

            // No action plans message
            ul.list-group.mt-1.mb-2(v-if="!actionPlans.length")
              li(class="list-group-item text-center text-muted font-weight-bold bg-light")
                | {{ $t('message.no_action_plans') }}

            // Action plans list
            b-row(v-if="item.type === 'in_term' && (item.executionResponsible === userData.worker_id.$oid || data.verificationResponsible === userData.worker_id.$oid || role === 'consultant')", v-for="(item, index) in actionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'corrective' ? 'border-warning' : ''}`")
              b-col(v-if="index % 2 === 0", md="12")
                hr(:class="index ? 'my-2' : 'mb-2'")
              
              b-col(md="3")
                b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
                  b-form-textarea(v-model="item.name", :disabled="true", :placeholder="$t('placeholder.name')")

              b-col(md="5")
                b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
                  b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")

              b-col(md="4")
                b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
                  v-select(
                    v-model="item.executionResponsible"
                    label="title"
                    :disabled="true"
                    :options="workersTotal"
                    :selectable="worker => !worker.deleted"
                    :reduce="worker => worker.value"
                    :placeholder="$t('placeholder.action_plan_responsible')"
                  )

              b-col(md="2")
                b-form-group(:label="$t('label.executionDate')", label-for="executionDate")
                  validation-provider(:name="`${$t('label.executionDate')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                    flat-pickr(
                      v-model="item.executionDate"
                      :config="flatPickrConfig"
                      :disabled="item.stage !== 'corrective'"
                      class="form-control"
                    )
                    small(class="text-danger") {{ errors[0] }}
              
              b-col(md="3")
                b-form-group(:label="$t('label.result')", :label-for="$t('label.result')")
                  validation-provider(:name="`${$t('label.result')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                    v-select(v-model="item.correctiveResult", :disabled="item.stage !== 'corrective'", label="title", :options="correctiveResultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="3")
                b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
                  validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                    v-select(v-model="item.correctiveNextStage", :disabled="item.correctiveResult !== 'rejected' || item.stage !== 'corrective'", label="title", :options="correctiveStageOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="4")
                b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
                  // Document Repository
                  document-repository(
                    :documents="item.evidenceFile"
                    :keys="item.evidence_key || []"
                    :read-only="item.evidence_key && item.evidence_key.length > 0"
                    type="evidence"
                    @add="(evidences) => handleAddEvidences(evidences, index)"
                    @delete="(evidenceIndex) => handleDeleteEvidences(evidenceIndex, index)"
                  )

                  small(v-if="!(item.evidenceFile && item.evidenceFile.length) && !(item.evidence_key && item.evidence_key.length) && item.stage === 'corrective' && item.correctiveNextStage === 'verification'", class="text-danger")
                    | {{ $t('message.upload_evidence_required') }}

              b-col(md="12")
                b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
                  validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                    b-form-textarea(v-model="item.correctiveComment", :disabled="item.stage !== 'corrective'", :placeholder="$t('placeholder.comment')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="4")
                b-form-checkbox(v-model="item.isRootCause" :disabled="true")
                  small
                    | {{ $t('label.rootCause') }}

              b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
                small
                  | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

              b-col(v-if="index % 2 === 0", md="12")
                hr(class="mb-2")

        // Verification
        tab-content(v-if="readOnly || stages[data.stage] >= 6 || actionPlans.some(e => e.stage === 'verification')", :title="$t('message.verification')")
          validation-observer(ref="verificationTab", tag="form")
            // Total verification title
            b-row
              b-col(md="6")
                h5.mb-1
                  | {{ $t('label.globalVerification') }}

            // Verify all action plans
            b-row
              b-col(:md="verifyAllCommentEnabled ? '4' : '12'")
                b-form-group(:label="$t('label.verifyAllActionPlans')", :label-for="$t('label.verifyAllActionPlans')")
                  b-button(
                    type="button"
                    variant="success"
                    @click="verifyAllActionPlans"
                    :disabled="!verifyAllEnabled || userData.worker_id.$oid !== data.verificationResponsible && role !== 'consultant'"
                  )
                    | {{ $t('message.verifyAll') }}
                  small(v-if="!verifyAllEnabled && data.stage === 'verification' && (userData.worker_id.$oid === data.verificationResponsible || role === 'consultant')", class="text-danger ml-1") {{ $t('message.mustSeeAllEvidences') }}
              b-col(v-if="verifyAllCommentEnabled", md="8")
                b-form-group(:label="$t('label.verificationComment')", :label-for="$t('label.verificationComment')")
                  validation-provider(:name="$t('label.verificationComment')", :rules="data.stage === 'verification' ? 'required' : ''", v-slot="{ errors }")
                    b-form-textarea(v-model="data.verificationComment", :disabled="data.stage === 'end'", :placeholder="$t('placeholder.comment')")
                    small(class="text-danger") {{ errors[0] }}
            
            // Title
            b-row(class="mt-1")
              b-col(md="12")
                h5(class="mb-0")
                  | {{ $t('label.actionPlans') }}

            // No action plans message
            ul.list-group.mt-1.mb-2(v-if="!verificationActionPlans.length")
              li(class="list-group-item text-center text-muted font-weight-bold bg-light")
                | {{ $t('message.no_action_plans') }}

            // Action plans list
            b-row(v-for="(item, index) in verificationActionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'verification' ? 'border-warning' : item.stage === 'end' ? 'border-success' : ''}`")
              b-col(v-if="index % 2 === 0", md="12")
                hr(:class="index ? 'my-2' : 'mb-2'")
              
              b-col(md="3")
                b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
                  b-form-textarea(v-model="item.name", :disabled="true", :placeholder="$t('placeholder.name')")

              b-col(md="5")
                b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
                  b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")

              b-col(md="4")
                b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
                  v-select(
                    v-model="item.executionResponsible"
                    label="title"
                    :disabled="true"
                    :options="workersTotal"
                    :selectable="worker => !worker.deleted"
                    :reduce="worker => worker.value"
                    :placeholder="$t('placeholder.action_plan_responsible')"
                  )

              b-col(md="2")
                b-form-group(:label="$t('label.executionDate')", label-for="executionDate")
                  flat-pickr(
                    v-model="item.executionDate"
                    :config="flatPickrConfig"
                    :disabled="true"
                    class="form-control"
                  )
              
              b-col(:md="item.type === 'in_term' ? '2' : '10'")
                b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
                  // Document Repository
                  document-repository(
                    :documents="[]"
                    :keys="item.evidence_key || []"
                    :read-only="true"
                    type="evidence"
                    @evidence-viewed="handleEvidenceViewed(item._id, $event, 'verification')"
                  )
              
              b-col(v-if="item.type === 'in_term'", md="3")
                b-form-group(:label="$t('label.correctiveResult')", :label-for="$t('label.correctiveResult')")
                  v-select(v-model="item.correctiveResult", :disabled="true", label="title", :options="correctiveResultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")

              b-col(v-if="item.type === 'in_term'", md="5")
                b-form-group(:label="$t('label.correctiveComment')", :label-for="$t('label.correctiveComment')")
                  b-form-textarea(v-model="item.correctiveComment", :disabled="true", :placeholder="$t('placeholder.comment')")

              b-col(md="3")
                b-form-group(:label="$t('message.verification')", :label-for="$t('message.verification')")
                  validation-provider(:name="`${$t('message.verification')} ${index + 1}`", :rules="item.stage === 'verification' ? 'required' : ''", v-slot="{ errors }")
                    v-select(v-model="item.verificationResult", :disabled="item.stage !== 'verification' || userData.worker_id.$oid !== data.verificationResponsible && role !== 'consultant'", label="title", :options="resultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="3")
                b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
                  validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'verification' ? 'required' : ''", v-slot="{ errors }")
                    v-select(v-model="item.verificationNextStage", :disabled="item.verificationResult !== 'rejected' || item.stage !== 'verification' || userData.worker_id.$oid !== data.verificationResponsible && role !== 'consultant'", label="title", :options="item.type === 'immediate' ? immediateVerificationStageOptions : inTermVerificationStageOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="6")
                b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
                  validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'verification' && !verifyAllCommentEnabled ? 'required' : ''", v-slot="{ errors }")
                    b-form-textarea(v-model="item.verificationComment", :disabled="item.stage !== 'verification' || userData.worker_id.$oid !== data.verificationResponsible && role !== 'consultant'", :placeholder="$t('placeholder.comment')")
                    small(class="text-danger") {{ errors[0] }}

              b-col(md="4")
                b-form-checkbox(v-model="item.isRootCause" :disabled="true")
                  small
                    | {{ $t('label.rootCause') }}

              b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
                small
                  | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

              b-col(v-if="index % 2 === 0", md="12")
                hr(class="mb-2")

  audit-log-table(
    v-if="(isEdit || readOnly) && data",
    :history="data.history || []",
    :field-translations="{ note: $t('label.Title'), assignee: $t('label.registration_responsible'), dueDate: $t('label.due_date'), description: $t('label.description'), associatedCases: $t('label.associated_cases'), areas: $t('label.operationalAreas'), proposalResponsible: $t('label.proposal_responsible'), approvalResponsible: $t('label.approval_responsible'), verificationResponsible: $t('label.verification_responsible'), proposalDueDate: $t('label.due_date_proposal'), approvalDueDate: $t('label.due_date_approval'), verificationDueDate: $t('label.due_date_verification'), problemStatement: $t('label.Problem'), why1: $t('label.Why1'), why2: $t('label.Why2'), why3: $t('label.Why3'), why4: $t('label.Why4'), why5: $t('label.Why5'), actionPlans: $t('label.actionPlans'), approvalComment: $t('label.approvalComment'), verificationComment: $t('label.verificationComment'), stage: $t('actualStage'), rootCause: $t('label.rootCause') }",
    stage-translation-prefix="caseStages"
  )
</template>

<script>
import vSelect from 'vue-select'
import { onMounted, ref, computed, watch } from '@vue/composition-api/dist/vue-composition-api'
import useCommon from '@/views/organization/useCommon'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import flatPickr from 'vue-flatpickr-component'
import { useRouter } from '@core/utils/utils'
import { stateOptions, actionPlanOptions, resultOptions, correctiveResultOptions, inTermApprovalStageOptions, correctiveStageOptions, immediateVerificationStageOptions, inTermVerificationStageOptions, flatPickrConfig, inputFileTypes } from '@/constants'
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { BFormDatepicker, BModal, VBModal, BFormCheckbox, BCard, BCardText } from "bootstrap-vue";
import awsConnection from '@/views/habit/aws'
import useCommonTodo from '@/views/apps/todo/useCommonTodo'
import store from '@/store'
import { useLambda } from '@/views/habit/awsLambda'
import DocumentRepository from '@/views/habit/DocumentRepository'
import InformationButton from '@/views/components/Shared/Buttons/InformationButton.vue'
import { oid, date } from '@/helpers/mongoHelpers'
import AuditLogTable from '@/components/AuditLogTable.vue'

export default {
  name: 'Form',
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
    flatPickr,
    FormWizard,
    TabContent,
    BFormDatepicker,
    BModal,
    BFormCheckbox,
    BCard,
    BCardText,
    DocumentRepository,
    InformationButton,
    AuditLogTable,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    updateActiveTab: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const { getWorkersTotalForDropDown, workersTotal, getImprovementsForDropDown, improvements, getLocationsForDropDown, locations, formatDate, formatDateAsYMD, createActionPlanEvent, updateActionPlanEvent, getBusinessDays, getCompaniesForDropDown, companies, getIDsForDropDown, ids, getProcessesForDropDown, processes, getCrimesForDropDown, crimes, getControlsForDropDown, controls, getWorkersSupervisedForDropDown, workersSupervised } = useCommon()
    const { router, route } = useRouter()
    const { singleUpload } = awsConnection()
    const { createItem, updateItem } = useLambda()
    const { sendEmailActionPlan, uploadFileToS3 } = useCommonTodo()
    const { role } = store.state?.userStore?.userData
    const form = ref(null)
    const documentFiles = ref([])
    const identificationTab = ref(null)
    const responsiblesTab = ref(null)
    const analysisTab = ref(null)
    const approvalTab = ref(null)
    const correctiveTab = ref(null)
    const verificationTab = ref(null)
    const actionPlanType = ref(null)
    const pacEnabled = computed(() => actionPlanType.value && props.data.why1 && (props.data.why2 || props.data.rootCause < 2) && (props.data.why3 || props.data.rootCause < 3) && (props.data.why4 || props.data.rootCause < 4) && (props.data.why5 || props.data.rootCause < 5))
    const userData = JSON.parse(localStorage.getItem('userData') || '{}')
    const actionPlans = ref([])
    const actionPlansToDelete = []
    const approveAllCommentEnabled = ref(false)
    const verifyAllCommentEnabled = ref(false)
    const actionPlansToApprove = ref([])
    const actionPlansToVerify = ref([])
    const linkedBehavioursAvailable = ref(false)
    const availableBehaviours = ref([])
    const stages = { registration: 1, analysis: 3, approval: 4, corrective: 5, verification: 6, end: 7 }
    const caseForm = ref(null)
    const updateActiveTab = ref(false)
    const allActionPlansBeyondAnalysis = computed(() => actionPlans.value.every(e => e.stage !== "analysis"))
    const now = new Date()
    const endOfToday = new Date()
    endOfToday.setHours(23, 59, 59, 999)
    const destinationFolder = `${userData.client.$oid}/documents`
    const tabs = [
      { title: i18n.t('message.identification'), name: 'identification', ref: identificationTab },
      { title: i18n.t('message.responsibles'), name: 'responsibles', ref: responsiblesTab },
      { title: i18n.t('message.analysis'), name: 'analysis', ref: analysisTab },
      { title: i18n.t('message.approval'), name: 'approval', ref: approvalTab },
      { title: i18n.t('message.corrective'), name: 'corrective', ref: correctiveTab },
      { title: i18n.t('message.verification'), name: 'verification', ref: verificationTab },
    ]

    const isPlanReady = (plan) => {
      return plan.evidence_key?.every(key => plan.evidenceViewedKeys?.includes(key))
    }

    const approveAllEnabled = computed(() => {
      return actionPlansToApprove.value.every(plan => plan.type === 'in_term' || isPlanReady(plan))
    })

    const verifyAllEnabled = computed(() => {
      return actionPlansToVerify.value.every(plan => isPlanReady(plan))
    })

    watch(props, () => {
      updateActiveTab.value = props.updateActiveTab
      actionPlans.value = props.data.actionPlans || []
      actionPlansToApprove.value = actionPlans.value.filter(e => e.stage === 'approval')
      actionPlansToVerify.value = actionPlans.value.filter(e => e.stage === 'verification')
      if (stages[props.data.stage] > 4) approveAllCommentEnabled.value = true
      if (props.data.stage === 'end') verifyAllCommentEnabled.value = true

      if (!linkedBehavioursAvailable.value && (props.data.behaviour?.name || props.data.linkedBehaviors?.length)) {
        linkedBehavioursAvailable.value = true
        availableBehaviours.value = props.data.behaviour?.name
          ? [{
              nameFormatted: props.data.behaviour.name.length > 100 ? `${props.data.behaviour.name.replace(/<[^>]*>/g, '').substring(0, 100)}...` : props.data.behaviour.name.replace(/<[^>]*>/g, ''),
              activity: props.data.activity,
              behaviour: props.data.behaviour.name,
              selected: true,
            }]
          : props.data.linkedBehaviors.map((b, index) => ({
              ...b,
              selected: true, // Por defecto todos seleccionados,
              nameFormatted: b.behaviour.length > 100 ? `${b.behaviour.replace(/<[^>]*>/g, '').substring(0, 100)}...` : b.behaviour.replace(/<[^>]*>/g, ''), // Formatear nombre para mostrar
            }))
      }
    })

    watch(updateActiveTab, () => {
      if (caseForm.value && stages[props.data.stage]) {
        let activeTabIndex = Math.min(stages[props.data.stage] - 1, caseForm.value.tabCount - 1)
        if (props.data.stage === 'corrective' && actionPlans.value.some(e => e.stage === 'verification')) {
          activeTabIndex = tabs.findIndex(t => t.name === 'verification')
        }
        caseForm.value.activateTab(activeTabIndex)
        caseForm.value.activeTabIndex = activeTabIndex
        caseForm.value.maxStep = Math.max(activeTabIndex, 1)
        caseForm.value.tabs.forEach((t, i) => t.checked = i <= Math.max(activeTabIndex, 1))
      }
    })

    watch(actionPlans, () => {
      actionPlans.value.forEach(e => {
        if (e.approvalResult === 'approved') e.approvalNextStage = e.type === 'immediate' ? 'verification' : 'corrective'
        if (e.correctiveResult === 'approved') e.correctiveNextStage = 'verification'
        if (e.verificationResult === 'approved') e.verificationNextStage = 'end'
        e.startDateConfig.maxDate = e.type === 'immediate' ? endOfToday : null
      })
    }, { deep: true })

    const handleAddDocuments = (newDocs) => {
      documentFiles.value.push(...newDocs)
    }

    const handleDeleteDocuments = (index) => {
      documentFiles.value.splice(index, 1)
    }

    const handleAddEvidences = (newEvidences, actionPlanIndex) => {
      actionPlans.value[actionPlanIndex].evidenceFile.push(...newEvidences)
    }

    const handleDeleteEvidences = (evidenceIndex, actionPlanIndex) => {
      actionPlans.value[actionPlanIndex].evidenceFile.splice(evidenceIndex, 1)
    }

    const addActionPlan = () => {
      if (!actionPlanType.value) return
      actionPlans.value.push({
        name: '',
        description: '',
        startDate: JSON.parse(JSON.stringify(now)),
        endDate: JSON.parse(JSON.stringify(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000))),
        startDateConfig: {
          ...flatPickrConfig,
          maxDate: actionPlanType.value === 'immediate' ? endOfToday : null,
        },
        endDateConfig: {
          ...flatPickrConfig,
          minDate: now,
        },
        evidenceFile: [],
        type: actionPlanType.value,
        executionResponsible: '',
        createdBy: userData.worker_id.$oid
      })
    }
    const deleteActionPlan = (id, index) => {
      if (id) actionPlansToDelete.push(id)
      actionPlans.value.splice(index, 1);
    }

    const openCase = (id) => {
      const routeData = router.resolve({ name: 'organization-case-view', params: { id } });
      window.open(routeData.href, '_blank');
    }

    const handleCheck = (checked, index) => {
      if (!checked) return

      // Uncheck all other action plans root causes checks
      actionPlans.value = actionPlans.value.map((e, i) => ({
        ...e,
        isRootCause: i === index, // Set only the clicked one to true
      }));
    }

    const formSubmitted = async () => {
      emit('isSubmitting')

      // Upload evidence files to AWS and then store evidence keys in an array
      let newEvidenceKeys = []

      for (const p of actionPlans.value) {
        if (!p.evidenceFile?.length) continue

        const uploadEvidencePromises = p.evidenceFile.map(file => {
          if (!file?.name) return null
          return new Promise((resolve, reject) => {
            uploadFileToS3(file, destinationFolder)
              .then((key) => resolve(key))
              .catch((err) => {
                console.log(err)
                resolve(null)
              })
          })
        }) || []

        const evidenceKeys = await Promise.all(uploadEvidencePromises)
        const evidenceKeysFiltered = evidenceKeys.filter(e => !!e)

        newEvidenceKeys = newEvidenceKeys.concat(evidenceKeysFiltered)
        p.evidenceKeys = evidenceKeysFiltered
      }

      const actionPlansCreationPromises = actionPlans.value.map((a, index) => {
        if (a._id) {
          if (a.stage === 'analysis' && (userData.worker_id.$oid === props.data.assignee || role === 'consultant')
            || a.stage === 'approval' && (userData.worker_id.$oid === props.data.approvalResponsible || role === 'consultant')
            || a.stage === 'corrective' && (userData.worker_id.$oid === a.executionResponsible || userData.worker_id.$oid === props.data.verificationResponsible || role === 'consultant')
            || a.stage === 'verification' && (userData.worker_id.$oid === props.data.verificationResponsible || role === 'consultant')
          ) {
            updateExistingActionPlan(a, props.data.stage)
          }
          return a._id
        }

        return createNewActionPlan(a, index)
      })

      const newActionPlanIds = await Promise.all(actionPlansCreationPromises)

      const filteredIds = newActionPlanIds.filter(e => !!e)

      // Preparar linkedBehaviors con solo los seleccionados
      const selectedBehaviours = availableBehaviours.value
        .filter(b => b.selected)
        .map(b => ({
          activity: b.activityName,
          behaviour: b.behaviourName,
          behaviourAnswer: b.behaviourAnswer,
          behaviourComment: b.behaviourComment || '',
        }))

      emit('submit', {
        ...props.data,
        documentFiles: documentFiles.value,
        actionPlansIds: filteredIds,
        actionPlansToDelete,
        newEvidenceKeys,
        linkedBehaviors: selectedBehaviours.length > 0 ? selectedBehaviours : undefined,
        confirmationId: route.value.query.evaluationId || undefined,
      })
    }

    const createNewActionPlan = async (actionPlan, index) => {
      try {
        const newActionPlan = {
          client_id: oid(userData.client.$oid),
          createdBy: oid(actionPlan.createdBy),
          evidence_key: actionPlan.type === 'immediate' && actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null,
          executionResponsible: actionPlan.executionResponsible ? oid(actionPlan.executionResponsible) : null,
          name: actionPlan.name,
          description: actionPlan.description,
          type: actionPlan.type,
          startDate: date(formatDate(actionPlan.startDate)),
          endDate: actionPlan.type === 'in_term' ? date(formatDate(actionPlan.endDate)) : null,
          executionDate: actionPlan.type === 'immediate' ? date(formatDate(actionPlan.startDate)) : null,
          stage: 'approval',
          originIndex: index,
          isRootCause: actionPlan.isRootCause || false,
          case: oid(props.data._id),
          lastModifiedBy: oid(userData.worker_id.$oid),
          lastModifiedDate: date(new Date()),
        }
  
        const { insertedId } = await createItem({ collection: 'action_plan', payload: newActionPlan })
  
        // Send email to execution responsible with the details of the action plan created
        newActionPlan.originId = props.data._id
        sendEmailActionPlan(newActionPlan, 'add', 'executionResponsible', 'case')
  
        const newActionPlanId = insertedId.toString()
        newActionPlan._id = newActionPlanId
        newActionPlan.startDate = formatDate(actionPlan.startDate),
        newActionPlan.endDate = actionPlan.type === 'in_term' ? formatDate(actionPlan.endDate) : null,
  
        createActionPlanEvent(newActionPlan)
  
        return newActionPlanId
      } catch (error) {
        console.log(error)
        return null
      }
    }

    const updateExistingActionPlan = async (actionPlan, caseStage) => {
      try {
        const query = { _id: oid(actionPlan._id) }
        
        let payload

        switch (actionPlan.stage) {
          case 'analysis':
            payload = {
              executionResponsible: actionPlan.executionResponsible ? oid(actionPlan.executionResponsible) : null,
              name: actionPlan.name,
              description: actionPlan.description,
              startDate: date(formatDate(actionPlan.startDate)),
              endDate: actionPlan.type === 'in_term' ? date(formatDate(actionPlan.endDate)) : null,
              stage: 'approval',
              approvalResult: '',
              approvalComment: '',
              isRootCause: actionPlan.isRootCause || false,
            }
            if (actionPlan.type === 'immediate') {
              payload.executionDate = date(formatDate(actionPlan.startDate))
              payload.evidence_key = actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null
            } else {
              payload.executionDate = null
              payload.evidence_key = null
            }
            break
          case 'approval':
            payload = {
              stage: actionPlan.approvalNextStage,
              approvalResult: actionPlan.approvalResult,
              approvalComment: actionPlan.approvalComment,
              correctiveResult: actionPlan.approvalNextStage === 'corrective' ? '' : null,
              correctiveComment: actionPlan.approvalNextStage === 'corrective' ? '' : null,
              verificationResult: actionPlan.approvalNextStage === 'verification' ? '' : null,
              verificationComment: actionPlan.approvalNextStage === 'verification' ? '' : null
            }
            if (actionPlan.type === 'immediate' && actionPlan.approvalNextStage === 'analysis') {
              payload.evidence_key = null
            }
            break
          case 'corrective':
            const actionPlanExecutionDate = formatDate(actionPlan.executionDate)
            payload = {
              executionDate: date(actionPlanExecutionDate),
              stage: actionPlan.correctiveNextStage,
              evidence_key: actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null,
              correctiveResult: actionPlan.correctiveResult,
              correctiveComment: actionPlan.correctiveComment,
              verificationResult: actionPlan.correctiveNextStage === 'verification' ? '' : null,
              verificationComment: actionPlan.correctiveNextStage === 'verification' ? '' : null
            }
            updateActionPlanEvent(actionPlan._id, actionPlanExecutionDate)
            break
          case 'verification':
            if (caseStage !== 'verification') break
            payload = {
              stage: actionPlan.verificationNextStage,
              verificationResult: actionPlan.verificationResult,
              verificationComment: actionPlan.verificationComment,
            }
            if (actionPlan.type === 'immediate' && actionPlan.verificationNextStage === 'analysis') {
              payload.evidence_key = null
            }
            if (actionPlan.type === 'in_term' && actionPlan.verificationNextStage === 'corrective') {
              payload.correctiveResult = ''
              payload.correctiveComment = ''
              payload.executionDate = null
              payload.evidence_key = null
            }
            break
          default:
            break
        }

        if (!payload) return

        payload.lastModifiedBy = oid(userData.worker_id.$oid)
        payload.lastModifiedDate = date(new Date())

        const action = { $set: payload }

        await updateItem({ collection: 'action_plan', query, action })
      } catch (error) {
        console.log(error)
      }
    }

    const handleEvidenceViewed = (actionPlanId, key, stage) => {
      const list = stage === 'approval'
        ? actionPlansToApprove.value
        : actionPlansToVerify.value

      const plan = list.find(p => p._id === actionPlanId)

      if (!plan) return

      // inicializar si no existe (MUY importante)
      if (!plan.evidenceViewedKeys) {
        plan.evidenceViewedKeys = []
      }

      // evitar duplicados
      if (plan.evidenceViewedKeys.includes(key)) return

      plan.evidenceViewedKeys.push(key)

      // 🔥 Vue 2 necesita esto para reactividad
      if (stage === 'approval') actionPlansToApprove.value = [...list]
      else actionPlansToVerify.value = [...list]
    }

    const approveAllActionPlans = () => {
      approveAllCommentEnabled.value = true
      actionPlans.value.forEach(e => {
        if (e.stage === 'approval') e.approvalResult = 'approved'
      })
    }

    const verifyAllActionPlans = () => {
      verifyAllCommentEnabled.value = true
      actionPlans.value.forEach(e => {
        if (e.stage === 'verification') e.verificationResult = 'approved'
      })
    }

    const validateTab = (tabRef, tabName) => new Promise((resolve, reject) => {
      if (role !== 'consultant' && (
          tabName === 'analysis' && userData.worker_id.$oid !== props.data.assignee
          || tabName === 'approval' && userData.worker_id.$oid !== props.data.approvalResponsible 
          || tabName === 'verification' && userData.worker_id.$oid !== props.data.verificationResponsible
        )
      ) {
        resolve(true)
      } else {
        tabRef.value.validate().then(success => {
          if (success) {
            // Validate that every 'immediate' (in stage 'analysis') and 'in term' (in stage 'corrective') action plans have an evidence selected to upload
            for (const actionPlan of actionPlans.value) {
              if ((tabName === 'analysis' && actionPlan.type === 'immediate'
                || tabName === 'corrective' && actionPlan.type === 'in_term' && actionPlan.stage === 'corrective' && actionPlan.correctiveNextStage === 'verification'
                && (userData.worker_id.$oid === actionPlan.executionResponsible || userData.worker_id.$oid === props.data.verificationResponsible || role === 'consultant'))
                && !actionPlan.evidenceFile?.length && !actionPlan.evidence_key?.length && !props.readOnly) {
                  console.log("not validated", actionPlan)
                  showErrorMessage(i18n.t('message.requiredFieldsIncomplete'))
                  return reject()
              }
            }
            resolve(true)
          }
          else {
            showErrorMessage(i18n.t('message.requiredFieldsIncomplete'))
            reject()
          }
        })
      }
    })

    // Watch for action plans start dates to update end dates for 'in_term' action plans
    watch(
      () => actionPlans.value.map(p => p.startDate),
      (newStartDates, oldStartDates) => {

        // If the lengths are different, we cannot compare them
        if (newStartDates.length !== oldStartDates?.length) return

        actionPlans.value.forEach((item, index) => {
          const newStart = newStartDates[index]
          const oldStart = oldStartDates[index]

          if (item.type === 'in_term' && newStart && formatDateAsYMD(formatDate(newStart)) !== formatDateAsYMD(formatDate(oldStart))) {
            const end = formatDate(newStart)
            end.setDate(end.getDate() + 7)
            item.endDate = end
            item.endDateConfig.minDate = item.startDate || null
          }
        })
      },
      { immediate: true }
    )

    const goToPreviousTab = () => {
      if (caseForm.value) {
        caseForm.value.prevTab()
      }
    }

    const goToNextTab = async () => {
      const index = caseForm.value.activeTabIndex

      try {
        await validateTab(tabs[index].ref, tabs[index].name)
        caseForm.value.nextTab()
      } catch (err) {
        // Error de validación, no avanza
      }
    }

    const validateAllTabs = async () => {
      const wizard = caseForm.value

      for (let i = 0; i < wizard.tabs.length; i++) {
        try {
          await validateTab(tabs[i].ref, tabs[i].name)
        } catch (error) {
          const failedTab = wizard.tabs[i]
          const tabTitle = failedTab.title

          if (i !== wizard.activeTabIndex) {
            showErrorMessage(i18n.tc('message.tabValidationError', 0, { tabTitle }))
          }
          
          throw error
        }
      }
    }

    const handleSubmit = async () => {
      try {
        await validateAllTabs()
        formSubmitted()
      } catch (error) {
        // Si alguna validación falla, no enviamos
      }
    }

    const proposalBusinessDays = computed(() => {
      return getBusinessDays(props.data?.dueDate, props.data?.proposalDueDate)
    })

    const approvalBusinessDays = computed(() => {
      return getBusinessDays(props.data?.dueDate, props.data?.approvalDueDate)
    })

    const verificationBusinessDays = computed(() => {
      return getBusinessDays(props.data?.dueDate, props.data?.verificationDueDate)
    })

    const displayStage = computed(() => {
      // Si la etapa es 'verification' y hay al menos 1 plan de acción en 'corrective', mostrar 'corrective'
      if (props.data.stage === 'verification' && actionPlans.value.some(plan => plan.stage === 'corrective')) {
        return 'corrective'
      }
      // Caso por defecto: mostrar la etapa del caso
      return props.data.stage
    })

    const verificationActionPlans = computed(() => {
      // Filtrar planes de acción que NO estén en etapa 'corrective'
      return actionPlans.value.filter(plan => plan.stage === 'verification' || plan.stage === 'end')
    })

    onMounted(() => {
      getWorkersTotalForDropDown()
      getImprovementsForDropDown()
      getLocationsForDropDown()
      getCompaniesForDropDown()
      getIDsForDropDown()
      getProcessesForDropDown()
      getCrimesForDropDown()
      getControlsForDropDown()
      getWorkersSupervisedForDropDown()

      // Detectar si viene desde evaluación
      if (route.value.query.fromEvaluation === 'true') {
        linkedBehavioursAvailable.value = true
        try {
          const behaviours = JSON.parse(route.value.query.behaviours || '[]')
          availableBehaviours.value = behaviours.map((b, index) => ({
            ...b,
            selected: true, // Por defecto todos seleccionados,
            nameFormatted: b.behaviourName.length > 100 ? `${b.behaviourName.replace(/<[^>]*>/g, '').substring(0, 100)}...` : b.behaviourName.replace(/<[^>]*>/g, ''), // Formatear nombre para mostrar
          }))
        } catch (error) {
          console.error('Error parsing behaviours:', error)
        }
      }
    })

    return {
      workersTotal,
      improvements,
      locations,
      companies,
      ids,
      processes,
      crimes,
      controls,
      workersSupervised,
      required,
      form,
      documentFiles,
      openCase,
      stateOptions,
      actionPlanOptions,
      resultOptions,
      correctiveResultOptions,
      inTermApprovalStageOptions,
      correctiveStageOptions,
      immediateVerificationStageOptions,
      inTermVerificationStageOptions,
      formSubmitted,
      validateTab,
      identificationTab,
      responsiblesTab,
      analysisTab,
      approvalTab,
      correctiveTab,
      verificationTab,
      actionPlanType,
      addActionPlan,
      deleteActionPlan,
      pacEnabled,
      actionPlans,
      userData,
      approveAllEnabled,
      verifyAllEnabled,
      approveAllCommentEnabled,
      verifyAllCommentEnabled,
      handleEvidenceViewed,
      approveAllActionPlans,
      verifyAllActionPlans,
      stages,
      linkedBehavioursAvailable,
      availableBehaviours,
      caseForm,
      allActionPlansBeyondAnalysis,
      flatPickrConfig,
      inputFileTypes,
      role,
      handleCheck,
      goToPreviousTab,
      goToNextTab,
      handleSubmit,
      handleAddDocuments,
      handleDeleteDocuments,
      handleAddEvidences,
      handleDeleteEvidences,
      proposalBusinessDays,
      approvalBusinessDays,
      verificationBusinessDays,
      displayStage,
      verificationActionPlans,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';

.custom-mt {
  margin-top: 5px;
}

.rounded.border-primary,
.rounded.border-warning {
  border-width: 2px !important;
}
</style>